import { Dayjs } from '@dw/dayjs'

export enum SYNC_PROVIDER {
  XERO = 'Xero'
}

export enum SYNC_ENTITY_TYPE {
  CONTACT = 'Contact',
  INVOICE = 'Invoice',
  PAYMENT = 'Payment'
}

export enum SYNC_DIRECTION {
  OUTBOUND = 'Outbound',
  INBOUND = 'Inbound'
}

export enum SYNC_ISSUE_STATUS {
  FAILED = 'Failed',
  RETRYING = 'Retrying',
  RESOLVED = 'Resolved',
  DISMISSED = 'Dismissed'
}

export enum SYNC_FAILURE_CATEGORY {
  RATE_LIMITED = 'RateLimited',
  INVOICE_LOCKED = 'InvoiceLocked',
  AUTH_EXPIRED = 'AuthExpired',
  VALIDATION = 'Validation',
  NOT_FOUND = 'NotFound',
  TRANSIENT = 'Transient',
  UNKNOWN = 'Unknown'
}

export interface ISyncIssue {
  id: string;
  provider: SYNC_PROVIDER;
  entityType: SYNC_ENTITY_TYPE;
  entityId: string;
  direction: SYNC_DIRECTION;
  operation: string;
  status: SYNC_ISSUE_STATUS;
  failureCategory: SYNC_FAILURE_CATEGORY;
  failureReason: string;
  retryable: boolean;
  canRetry: boolean;
  attemptCount: number;
  firstFailedUtc: Dayjs;
  lastFailedUtc: Dayjs;
  lastRetriedUtc?: Dayjs;
  resolvedUtc?: Dayjs;
}

export interface IBulkSyncIssuesActionResponse {
  processedCount: number;
  skippedCount: number;
}
